import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxActionSheetModule,
  DxButtonModule,
  DxPopoverModule,
  DxToolbarModule,
  DxTooltipModule
} from "devextreme-angular";
import {FormTypes} from "../../../models/ortak.dtos";
import {DxButtonTypes} from "devextreme-angular/ui/button";
import { UtilsService } from '../../../services/utils.service';


@Component({
  selector: 'dk-report-footer',
  standalone: true,
  imports: [CommonModule, DxToolbarModule, DxButtonModule, DxActionSheetModule, DxTooltipModule, DxPopoverModule],
  templateUrl: './report-footer.component.html',
  styleUrls: ['./report-footer.component.scss'],
})
export class ReportFooterComponent {
  @Input() reportCode = '';
  formType: FormTypes=FormTypes.ReportForm;
  formTypes=FormTypes;
  @Input() listAction = '';
  @Input() errorResponse: string[];
  showPopover = false;
  helpButtonTarget='';

  toastMessageButtonOptions: DxButtonTypes.Properties = {
    icon: 'belloutline',
    stylingMode: 'outlined',
    hint: 'Hata Mesajları',
    onClick: () => {
      this.showLastErr(this.errorResponse)
    },
  };


  helpButtonOptions: DxButtonTypes.Properties = {
    icon: 'comment',
    stylingMode: 'outlined',
    hint:'Yardım',
    onClick: () => {

    },
  };

  constructor(private utilsService: UtilsService,
  ) {
  }



  showLastErr(err: any) {
    if(err.length>0){
      this.utilsService.showError(err,'','toast-bottom-right')
    }
  }
  getFormName(page:any):string{
    return page.slice(page.lastIndexOf("/") + 1)
  }

}
